export const CORE_INDICATOR_KEYS = [
  'bollingerBands',
  'botTrades',
  'cmVixFixUcsSqueeze',
  'candleHelper',
  'colorProTradingSuiteV3',
  'colorProTradingSuiteV31',
  'colorProTradingSuiteV31Strategy',
  'ichimokuCloud',
  'movingAverage',
  'murreyMathLinesV6',
  'macd',
  'rsi',
  'traderPro17',
  'traderPro17Strategy',
  'openCode5mStrategy',
  'traderProV3',
  'volume',
] as const;

export const BASIC_INDICATOR_DEFINITIONS = {
  ema: {
    label: 'Moving Average Exponential',
    tvScriptId: 'STD;EMA',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  wma: {
    label: 'Moving Average Weighted',
    tvScriptId: 'STD;WMA',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  hma: {
    label: 'Hull Moving Average',
    tvScriptId: 'STD;Hull%1MA',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  dema: {
    label: 'Double EMA',
    tvScriptId: 'STD;DEMA',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  tema: {
    label: 'Triple EMA',
    tvScriptId: 'STD;TEMA',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  vwma: {
    label: 'Volume Weighted Moving Average',
    tvScriptId: 'STD;VWMA',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  vwap: {
    label: 'Volume Weighted Average Price',
    tvScriptId: 'STD;VWAP',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  supertrend: {
    label: 'Supertrend',
    tvScriptId: 'STD;Supertrend',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  parabolicSar: {
    label: 'Parabolic SAR',
    tvScriptId: 'STD;PSAR',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  donchianChannels: {
    label: 'Donchian Channels',
    tvScriptId: 'STD;Donchian_Channels',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  stochastic: {
    label: 'Stochastic',
    tvScriptId: 'STD;Stochastic',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  stochasticRsi: {
    label: 'Stochastic RSI',
    tvScriptId: 'STD;Stochastic_RSI',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  cci: {
    label: 'Commodity Channel Index',
    tvScriptId: 'STD;CCI',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  williamsR: {
    label: 'Williams Percent Range',
    tvScriptId: 'STD;Willams_R',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  roc: {
    label: 'Rate Of Change',
    tvScriptId: 'STD;ROC',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  ultimateOscillator: {
    label: 'Ultimate Oscillator',
    tvScriptId: 'STD;Ultimate_Oscillator',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  awesomeOscillator: {
    label: 'Awesome Oscillator',
    tvScriptId: 'STD;Awesome_Oscillator',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  aroon: {
    label: 'Aroon',
    tvScriptId: 'STD;Aroon',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  aroonOscillator: {
    label: 'Aroon Oscillator',
    tvScriptId: 'STD;Aroon_Oscillator',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  trendStrengthIndex: {
    label: 'Trend Strength Index',
    tvScriptId: 'STD;Trend%1Strength%1Index',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  atr: {
    label: 'Average True Range',
    tvScriptId: 'STD;Average_True_Range',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  adx: {
    label: 'Average Directional Index',
    tvScriptId: 'STD;Average%1Directional%1Index',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  dmi: {
    label: 'Directional Movement Index',
    tvScriptId: 'STD;DMI',
    pane: true,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  mfi: {
    label: 'Money Flow Index',
    tvScriptId: 'STD;Money_Flow',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  obv: {
    label: 'On Balance Volume',
    tvScriptId: 'STD;On_Balance_Volume',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  chaikinMoneyFlow: {
    label: 'Chaikin Money Flow',
    tvScriptId: 'STD;Chaikin_Money_Flow',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  cumulativeVolumeDelta: {
    label: 'Cumulative Volume Delta',
    tvScriptId: 'STD;Cumulative%1Volume%1Delta',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  priceVolumeTrend: {
    label: 'Price Volume Trend',
    tvScriptId: 'STD;Price_Volume_Trend',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  bollingerBandwidth: {
    label: 'Bollinger BandWidth',
    tvScriptId: 'STD;Bollinger_Bands_Width',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  bollingerPercentB: {
    label: 'Bollinger Bands %b',
    tvScriptId: 'STD;Bollinger_Bands_B',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  volume24h: {
    label: '24-hour Volume',
    tvScriptId: 'STD;24h%Volume',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  accumulationDistribution: {
    label: 'Accumulation/Distribution',
    tvScriptId: 'STD;Accumulation_Distribution',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  advanceDeclineLine: {
    label: 'Advance Decline Line',
    tvScriptId: 'STD;Advance%1Decline%1Line',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  advanceDeclineRatio: {
    label: 'Advance Decline Ratio',
    tvScriptId: 'STD;Advance%1Decline%1Ratio',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  advanceDeclineRatioBars: {
    label: 'Advance/Decline Ratio (Bars)',
    tvScriptId: 'STD;Advance_Decline_Ratio_Bars',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  arnaudLegouxMovingAverage: {
    label: 'Arnaud Legoux Moving Average',
    tvScriptId: 'STD;Arnaud%1Legoux%1Moving%1Average',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  autoFibExtension: {
    label: 'Auto Fib Extension',
    tvScriptId: 'STD;Auto%1Fib%1Extension%1',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  autoFibRetracement: {
    label: 'Auto Fib Retracement',
    tvScriptId: 'STD;Auto%1Fib%1Retracement%1',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  autoPitchfork: {
    label: 'Auto Pitchfork',
    tvScriptId: 'STD;Auto%1Pitchfork',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  autoTrendDetector: {
    label: 'Auto Trend Detector',
    tvScriptId: 'STD;Auto_Trend_Detector',
    pane: false,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  averageDailyRange: {
    label: 'Average Daily Range',
    tvScriptId: 'STD;Average%Day%Range',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  bbTrend: {
    label: 'BBTrend',
    tvScriptId: 'STD;BBTrend',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  balanceOfPower: {
    label: 'Balance of Power',
    tvScriptId: 'STD;Balance%1of%1Power',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  bollingerBars: {
    label: 'Bollinger Bars',
    tvScriptId: 'STD;Bollinger%1Bars',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  bullBearPower: {
    label: 'Bull Bear Power',
    tvScriptId: 'STD;Bull%Bear%Power',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  chaikinOscillator: {
    label: 'Chaikin Oscillator',
    tvScriptId: 'STD;Chaikin_Oscillator',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  chartPatterns: {
    label: 'Chart Patterns',
    tvScriptId: 'STD;Chart_Patterns',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  chandeKrollStop: {
    label: 'Chande Kroll Stop',
    tvScriptId: 'STD;Chande%1Kroll%1Stop',
    pane: false,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  chandeMomentumOscillator: {
    label: 'Chande Momentum Oscillator',
    tvScriptId: 'STD;Chande_Momentum_Oscillator',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  chandelierExit: {
    label: 'Chandelier Exit',
    tvScriptId: 'STD;Chandelier_Exit',
    pane: false,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  chopZone: {
    label: 'Chop Zone',
    tvScriptId: 'STD;Chop%1Zone',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  choppinessIndex: {
    label: 'Choppiness Index',
    tvScriptId: 'STD;Choppiness_Index',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  connorsRsi: {
    label: 'Connors RSI',
    tvScriptId: 'STD;Connors_RSI',
    pane: true,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  coppockCurve: {
    label: 'Coppock Curve',
    tvScriptId: 'STD;Coppock%1Curve',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  correlationCoefficient: {
    label: 'Correlation Coefficient',
    tvScriptId: 'STD;Correlation_Coeff',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  cumulativeVolumeIndex: {
    label: 'Cumulative Volume Index',
    tvScriptId: 'STD;Cumulative%1Volume%1Index',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  detrendedPriceOscillator: {
    label: 'Detrended Price Oscillator',
    tvScriptId: 'STD;DPO',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  easeOfMovement: {
    label: 'Ease of Movement',
    tvScriptId: 'STD;EOM',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  elderForceIndex: {
    label: 'Elder Force Index',
    tvScriptId: 'STD;EFI',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  envelope: {
    label: 'Envelope',
    tvScriptId: 'STD;ENV',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  fisherTransform: {
    label: 'Fisher Transform',
    tvScriptId: 'STD;Fisher_Transform',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  gaps: {
    label: 'Gaps',
    tvScriptId: 'STD;Gaps',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  historicalVolatility: {
    label: 'Historical Volatility',
    tvScriptId: 'STD;Historical_Volatility',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  kaufmanAdaptiveMovingAverage: {
    label: "Kaufman's Adaptive Moving Average",
    tvScriptId: 'STD;Kaufmans_Adaptive_Moving_Average',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  keltnerChannels: {
    label: 'Keltner Channels',
    tvScriptId: 'STD;Keltner_Channels',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  klingerOscillator: {
    label: 'Klinger Oscillator',
    tvScriptId: 'STD;Klinger%1Oscillator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  knowSureThing: {
    label: 'Know Sure Thing',
    tvScriptId: 'STD;Know_Sure_Thing',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  leastSquaresMovingAverage: {
    label: 'Least Squares Moving Average',
    tvScriptId: 'STD;Least%1Squares%1Moving%1Average',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  linearRegressionChannel: {
    label: 'Linear Regression Channel',
    tvScriptId: 'STD;Linear_Regression',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  maCross: {
    label: 'MA Cross',
    tvScriptId: 'STD;MA%1Cross',
    pane: false,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  massIndex: {
    label: 'Mass Index',
    tvScriptId: 'STD;Mass%1Index',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  mcGinleyDynamic: {
    label: 'McGinley Dynamic',
    tvScriptId: 'STD;McGinley%1Dynamic',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  median: {
    label: 'Median',
    tvScriptId: 'STD;Median',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  momentum: {
    label: 'Momentum',
    tvScriptId: 'STD;Momentum',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  moonPhases: {
    label: 'Moon Phases',
    tvScriptId: 'STD;Moon%1Phases',
    pane: false,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  movingAverageRibbon: {
    label: 'Moving Average Ribbon',
    tvScriptId: 'STD;MA%Ribbon',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  multiTimePeriodCharts: {
    label: 'Multi-Time Period Charts',
    tvScriptId: 'STD;Multi-Time%Period%Charts',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  negativeVolumeIndex: {
    label: 'Negative Volume Index',
    tvScriptId: 'STD;Negative_Volume_Index',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  netVolume: {
    label: 'Net Volume',
    tvScriptId: 'STD;Net%1Volume',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  openInterest: {
    label: 'Open Interest',
    tvScriptId: 'STD;Open%Interest',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  percentagePriceOscillator: {
    label: 'Percentage Price Oscillator',
    tvScriptId: 'STD;Price_Oscillator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  percentageVolumeOscillator: {
    label: 'Percentage Volume Oscillator',
    tvScriptId: 'STD;Volume%1Oscillator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  performance: {
    label: 'Performance',
    tvScriptId: 'STD;Performance',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  pivotPointsHighLow: {
    label: 'Pivot Points High Low',
    tvScriptId: 'STD;Pivot%1Points%1High%1Low',
    pane: false,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  pivotPointsStandard: {
    label: 'Pivot Points Standard',
    tvScriptId: 'STD;Pivot%1Points%1Standard',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  positiveVolumeIndex: {
    label: 'Positive Volume Index',
    tvScriptId: 'STD;Positive_Volume_Index',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  priceMomentumOscillator: {
    label: 'Price Momentum Oscillator',
    tvScriptId: 'STD;Price_Momentum_Oscillator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  priceTarget: {
    label: 'Price Target',
    tvScriptId: 'STD;Price%1Target',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  pringsSpecialK: {
    label: "Pring's Special K",
    tvScriptId: 'STD;Prings_Special_K',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  rciRibbon: {
    label: 'RCI Ribbon',
    tvScriptId: 'STD;RCI_Ribbon',
    pane: true,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  rsiDivergenceIndicator: {
    label: 'RSI Divergence Indicator',
    tvScriptId: 'STD;Divergence%1Indicator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  rankCorrelationIndex: {
    label: 'Rank Correlation Index',
    tvScriptId: 'STD;Rank_Correlation_Index',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  relativeVigorIndex: {
    label: 'Relative Vigor Index',
    tvScriptId: 'STD;Relative_Vigor_Index',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  relativeVolatilityIndex: {
    label: 'Relative Volatility Index',
    tvScriptId: 'STD;Relative_Volatility_Index',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  relativeVolumeAtTime: {
    label: 'Relative Volume at Time',
    tvScriptId: 'STD;Relative%1Volume%1at%1Time',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  robBookerZivGhostPivots: {
    label: 'Rob Booker - Ziv Ghost Pivots',
    tvScriptId: 'STD;Rob%1Booker%1Ghost%1Pivots%1v2',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  smiErgodicIndicator: {
    label: 'SMI Ergodic Indicator',
    tvScriptId: 'STD;SMI_Ergodic_Indicator_Oscillator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  smiErgodicOscillator: {
    label: 'SMI Ergodic Oscillator',
    tvScriptId: 'STD;SMI_Ergodic_Oscillator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  seasonality: {
    label: 'Seasonality',
    tvScriptId: 'STD;Seasonality',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  smoothedMovingAverage: {
    label: 'Smoothed Moving Average',
    tvScriptId: 'STD;Smoothed%1Moving%1Average',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  stochasticMomentumIndex: {
    label: 'Stochastic Momentum Index',
    tvScriptId: 'STD;SMI',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  trix: {
    label: 'TRIX',
    tvScriptId: 'STD;TRIX',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  technicalRatings: {
    label: 'Technical Ratings',
    tvScriptId: 'STD;Technical%1Ratings',
    pane: true,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  timeWeightedAveragePrice: {
    label: 'Time Weighted Average Price',
    tvScriptId: 'STD;Time%1Weighted%1Average%1Price',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  tradingSessions: {
    label: 'Trading Sessions',
    tvScriptId: 'STD;Trading%1Sessions',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  trueStrengthIndex: {
    label: 'True Strength Index',
    tvScriptId: 'STD;True%1Strength%1Indicator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  ulcerIndex: {
    label: 'Ulcer Index',
    tvScriptId: 'STD;Ulcer_Index',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  upDownVolume: {
    label: 'Up/Down Volume',
    tvScriptId: 'STD;UP_DOWN_Volume',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  visibleAveragePrice: {
    label: 'Visible Average Price',
    tvScriptId: 'STD;Visible%1Average%1Price',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  volatilityStop: {
    label: 'Volatility Stop',
    tvScriptId: 'STD;Volatility_Stop',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
  volumeDelta: {
    label: 'Volume Delta',
    tvScriptId: 'STD;Volume%1Delta',
    pane: true,
    series: { secondary: false, tertiary: false, histogram: true },
  },
  vortexIndicator: {
    label: 'Vortex Indicator',
    tvScriptId: 'STD;Vortex%1Indicator',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  williamsAlligator: {
    label: 'Williams Alligator',
    tvScriptId: 'STD;Williams_Alligator',
    pane: false,
    series: { secondary: true, tertiary: true, histogram: false },
  },
  williamsFractals: {
    label: 'Williams Fractals',
    tvScriptId: 'STD;Whilliams_Fractals',
    pane: false,
    series: { secondary: true, tertiary: false, histogram: false },
  },
  woodiesCci: {
    label: 'Woodies CCI',
    tvScriptId: 'STD;Woodies%1CCI',
    pane: true,
    series: { secondary: true, tertiary: false, histogram: true },
  },
  zigZag: {
    label: 'Zig Zag',
    tvScriptId: 'STD;Zig_Zag',
    pane: false,
    series: { secondary: false, tertiary: false, histogram: false },
  },
} as const;

export type BasicIndicatorKeyRaw = keyof typeof BASIC_INDICATOR_DEFINITIONS;

export const BASIC_INDICATOR_KEYS = Object.keys(BASIC_INDICATOR_DEFINITIONS) as BasicIndicatorKeyRaw[];

export const CORE_INDICATOR_OPTIONS = [
  {
    key: 'bollingerBands',
    label: 'Bollinger Bands',
    settingsTarget: 'bollingerBands',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'botTrades',
    label: 'Bot Trades',
    settingsTarget: 'botTrades',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'cmVixFixUcsSqueeze',
    label: 'CM VixFix + Squeeze',
    settingsTarget: 'cmVixFixUcsSqueeze',
    pane: true,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'candleHelper',
    label: 'Candle Helper',
    settingsTarget: 'candleHelper',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'colorProTradingSuiteV3',
    label: 'ColorPro v3',
    settingsTarget: 'colorProTradingSuiteV3',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'colorProTradingSuiteV31',
    label: 'ColorPro v3.1',
    settingsTarget: 'colorProTradingSuiteV31',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'colorProTradingSuiteV31Strategy',
    label: 'ColorPro v3.1 Strategy',
    settingsTarget: 'colorProTradingSuiteV31Strategy',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'ichimokuCloud',
    label: 'Ichimoku Cloud',
    settingsTarget: 'ichimokuCloud',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'movingAverage',
    label: 'MA',
    settingsTarget: 'movingAverage',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'murreyMathLinesV6',
    label: 'Murrey Math Lines v6',
    settingsTarget: 'murreyMathLinesV6',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'macd',
    label: 'MACD',
    settingsTarget: 'macd',
    pane: true,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'rsi',
    label: 'RSI',
    settingsTarget: 'rsi',
    pane: true,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'traderPro17',
    label: 'Trader Pro 1.7',
    settingsTarget: 'traderPro17',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'traderPro17Strategy',
    label: 'Trader Pro 1.7 Strategy',
    settingsTarget: 'traderPro17Strategy',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'openCode5mStrategy',
    label: 'OpenCode 5m Strategy',
    settingsTarget: 'openCode5mStrategy',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'traderProV3',
    label: 'Trader Pro v3',
    settingsTarget: 'traderProV3',
    pane: false,
    defaultEnabled: false,
    isBasic: false,
  },
  {
    key: 'volume',
    label: 'Volume',
    settingsTarget: 'volume',
    pane: false,
    defaultEnabled: true,
    isBasic: false,
  },
] as const;

export const BASIC_INDICATOR_OPTIONS = BASIC_INDICATOR_KEYS.map((key) => ({
  key,
  label: BASIC_INDICATOR_DEFINITIONS[key].label,
  settingsTarget: key,
  pane: BASIC_INDICATOR_DEFINITIONS[key].pane,
  defaultEnabled: false,
  isBasic: true,
}));

export const INDICATOR_OPTIONS = [...CORE_INDICATOR_OPTIONS, ...BASIC_INDICATOR_OPTIONS] as const;

export const PANE_INDICATOR_KEYS = INDICATOR_OPTIONS.filter((option) => option.pane).map(
  (option) => option.key,
);

export function isBasicIndicatorKey(value: string): value is BasicIndicatorKeyRaw {
  return value in BASIC_INDICATOR_DEFINITIONS;
}
